module.exports = __webpack_public_path__ + "c697a94cb1931313f55696eeca71db3e.svg";